/**
 * Formats getAllSegment response into tabular form
 */

function segmentListFormatter(list) {
  if (!Array.isArray(list)) {
    return [];
  }
  return list?.map(segment => {
    const adjustedSegment = {};
    const { segmentId, segmentName, segmentDescription } = segment?.segmentIdentifier ?? {};
    adjustedSegment.segmentName = segmentName;
    adjustedSegment.isSelected = false;
    adjustedSegment.segmentId = segmentId;
    adjustedSegment.segmentDescription = segmentDescription ?? '';
    adjustedSegment.segmentType = 'type1';
    adjustedSegment.lastUpdatedDate = new Date(
      +segment.lastUpdatedDate * 1000,
    ).toLocaleDateString();
    adjustedSegment.lastUpdatedBy = segment.lastUpdatedBy;
    adjustedSegment.status = segment.status;
    return adjustedSegment;
  });
}

export default segmentListFormatter;
